export default __webpack_public_path__ + "static/media/LUZ.59872a02.svg";